// This configuration is populated at runtime by site_config_setup in application_helper.rb
const config = window.site_config || {};
export default config;
